import { Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import CommunitiesOfPractitioners from 'pages/CommunitiesOfPractitioners'

export function App() {
  return (
    <BrowserRouter basename="/communities-of-practitioners">
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<CommunitiesOfPractitioners />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
